import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import { Spin, Typography, Tooltip, Card, Skeleton } from "antd";
import { StarFilled } from "@ant-design/icons";
import ProductSectionNew from "../../components/common/ProductSectionNew";
import BestValueProductSection from "../../components/common/BestValueProductSection";
import TopValuePicksComparison from "../../components/common/TopValuePicksComparison";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import joyLogo from "../../assests/Images/joyLogo.png";
import { trackingService } from "../../services/api/trackingService.js";
import "./ProductPage.css";
import ProductListSection from "../../components/common/ProductListSection";
import HomeIcon from "../../assests/Images/home.svg";
import WebIcon from "../../assests/Images/web.svg";
import LogoIcon from "../../assests/Images/kangaroo.webp";
import SearchIcon from "../../assests/Images/list.svg";
import { SidebarNav, MobileBottomNav } from "../../components/common/ChatNavigation.js";
import ProductSkeleton from "../../components/common/ProductSkeleton.js";
import logoIcon from "../../assests/Images/kangaroo.webp";

export default function ProductPage({ loadingSkeleton = false, partialData, phone, productId, keyword,shopperooRender=false,onRenderComplete }) {
  let { phoneNumber, id } = useParams();

  if (!phoneNumber && !id && !loadingSkeleton) {
    phoneNumber = phone;
    id = productId;
  }

  //  phoneNumber="+913230795798";
    // id="f879c2a016144d78a535b3d51c3e370f";
  // phoneNumber="";
  // id="";
  // loadingSkeleton=true

  // partialData=[
  // //   {"asin": null,"image": "https://i5.walmartimages.com/seo/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz_e0381642-9489-4690-bc57-d4fd6e1dad53.0bf9af70aa26af70425c00bcdb784441.jpeg","key": "2LD84696JNJL","link": "https://www.walmart.com/ip/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz/585856048?classType=REGULAR","price": "14.99","rating": "4.9","reviews": "2684","store": "Walmart","title": "Valhalla Java Odinforce Blend Strong Whole Bean Coffee, 12 oz"},
  // //     {"asin":"B007PM9YNA","image": "https://m.media-amazon.com/images/I/71BP8kUMVPL._AC_UL320_.jpg","key": "B007PM9YNA","link": "https://www.amazon.com/Kauai-Whole-Coffee-Estate-Medium/dp/B007PM9YNA/?tag=meetpoppins-20","price": "7.68","rating": "4.4","reviews": "1900","store": "Amazon","title": "Kauai Coffee Koloa Estate Medium Roast - Whole Bean Coffee, 10 oz Package"},
  // //     {"asin":"","image": "","key": "","link": "","price": "","rating": "","reviews": "","store": "","title": ""},
  //  ]

  const { Text } = Typography;
  const isDesktop = useMediaQuery("(min-width:768px)");
  const [activeNav, setActiveNav] = useState(2);

  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [comparisonData, setComparisonData] = useState([]);

  // New state for floating component
  const [showFloating, setShowFloating] = useState(true);
  const comparisonRef = useRef(null);
  const hasCalledOnRenderRef = useRef(false);
  const hasCalledOnRenderRef1 = useRef(false);

  const mainRef = useRef(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [isSubmittingPhone, setIsSubmittingPhone] = useState(false);

  const bottomNavHeight = isDesktop ? 0 : 0;
  const icons = [WebIcon, LogoIcon, SearchIcon];
  const routes = [
    "https://www.shopperoo.us/",
    "/chatbot",
    "/shopping",
  ];

  useEffect(() => {
      // Only call onRenderComplete once when data is first loaded
      if (!loadingSkeleton && onRenderComplete && !hasCalledOnRenderRef1.current && productData) {
        hasCalledOnRenderRef1.current = true;
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          onRenderComplete(true);
        }, 100);
      }
    }, [loadingSkeleton, productData]);

    useEffect(() => {
      // Only call onRenderComplete once when data is first loaded
      if (loadingSkeleton) {
        hasCalledOnRenderRef1.current = true;
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          onRenderComplete(false);
        }, 100);
      }
    }, [loadingSkeleton]);

  useEffect(() => {
    if (!phoneNumber && !id) return;
    setLoading(true);
    UIRecommendationAPIService.uiRecommend(phoneNumber, id)
      .then((response) => {
        setProductData(response || {});
        if (phoneNumber && response) {
          trackingService.trackPageVisit(
            phoneNumber,
            id || 'unknown',
            response?.keywords || response?.display_keywords || 'unknown'
          );
        }

        comparisonData.push(response?.top_rated_products?.[0]);
        comparisonData.push(response?.lowest_priced_products?.[0]);
        comparisonData.push(response?.best_value_products?.[0]);
      })
      .catch((err) => console.error("Error fetching product data:", err))
      .finally(() => setLoading(false));
  }, [phoneNumber, id]);

  // Scroll handler to show/hide floating component
  // Update the scroll handler useEffect
useEffect(() => {
  const handleScroll = () => {
    if (comparisonRef.current && !hasCalledOnRenderRef.current) {
      hasCalledOnRenderRef.current = true;
      const comparisonRect = comparisonRef.current.getBoundingClientRect();

      console.log('Scroll detected, bottom:', comparisonRect.bottom); // Debug line

      // Show when comparison section scrolls past viewport
      if (comparisonRect.bottom < 100) {
        setShowFloating(true);
      } else {
        // setShowFloating(false);
      }
    }
  };

  // Listen to window scroll instead
  window.addEventListener('scroll', handleScroll);
  // Check on mount
  handleScroll();

  return () => window.removeEventListener('scroll', handleScroll);
}, [productData, partialData, loading]);


  const handlePhoneSubmit = async () => {
  // Validate phone number
  const phoneInput = document.getElementById("userPhoneNumber").value.trim();

  // if (!phoneInput) {
  //   // Show error or alert if phone number is empty
  //   alert("Please enter your phone number");
  //   return;
  // }

  setIsSubmittingPhone(true);

    // Make your API call here
    const messageText = "Hey Roo! Show me what I'm overpaying for 🎯"
    // Example API call - replace with your actual endpoint
   const formData = new URLSearchParams();
          formData.append("From", phoneInput);
          formData.append("Body", messageText);

          fetch(process.env.REACT_APP_TEXTROO_WEBHOOK_URL, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData.toString(),
          })
            .then((response) => {
              // document.getElementById("userPhoneNumber").value = "";
              setUserPhoneNumber("");
            })
            .catch(() => "")
            .finally(() => {
              // document.getElementById("userPhoneNumber").value = "";
              // Reset submission flag after delay
              setTimeout(() => {
                // setIsSubmittingPhone(false);
                setUserPhoneNumber("");

              }, 3000);
            });
};


  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 8,
          px: 2,
        }}
      >
        <Box
          sx={{
            fontSize: 60,
            color: "#ff007f",
            animation: "bounce 1s infinite",
            "@keyframes bounce": {
              "0%, 100%": { transform: "translateY(0)" },
              "50%": { transform: "translateY(-10px)" },
            },
          }}
        >
          <img src={logoIcon} style={{ width: "60px", height: "60px" }} />
        </Box>

        <Typography
          variant="h4"
          align="center"
          sx={{ maxWidth: 400, fontWeight: "bold", color: "#333" }}
        >
          {loadingSkeleton ? "Loading" : "Displaying your results…"}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", minHeight: "40vh", bgcolor: "white", position: "relative" }}>
        {!productData && !partialData ? (
          <p style={{ textAlign: "center", marginTop: "4rem" }}>No data available</p>
        ) : (
          <main
            ref={mainRef}
            className="product-section-new"
            style={{
              flex: 1,
              overflowY: "auto",
              paddingBottom: !isDesktop ? bottomNavHeight :0, // Extra space for floating component
            }}
          >
            <div ref={comparisonRef}>
              {/* <TopValuePicksComparison
                products={productData?.comparison_data}
                bestValueProducts={comparisonData}
                partialData={loadingSkeleton ? partialData : []}
                keyword={keyword}
                phoneNumber={phoneNumber}
              /> */}
            </div>

            <ProductListSection
              bestValueProducts={productData?.best_value_products}
              topRatedProducts={productData?.top_rated_products}
              lowestPricedProducts={productData?.lowest_priced_products}
              loadingSkeleton={loadingSkeleton}
              phoneNumber={phoneNumber}
              amazonSavingamount={productData?.amazon_savings_amount}
              amazonSavingPercentage={productData?.amazon_savings_percent}
              shopperooRender
              partialData={partialData}
              // pageView="shopperoo"

            />
          </main>
        )}

        {/* Floating Component */}
        {showFloating && productData && (
//   <Box
//     sx={{
//       position: "fixed",
//       bottom: 0,
//       left: 0,
//       right: 0,
//       backgroundColor: "rgba(0, 0, 0, 0.80)", // Black with 85% opacity
//       boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
//       padding: "16px",
//       zIndex: 1000,
//       transition: "transform 0.3s ease-in-out",
//       transform: showFloating ? "translateY(0)" : "translateY(100%)",
//       borderRadius:"10px"
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         gap: 2,
//         maxWidth: "1200px",
//         margin: "0 auto",
//       }}
//     >
//       {/* Main Text */}
//       {!isSubmittingPhone &&
//       <Typography
//         style={{
//           color: "white",
//           textAlign: "center",
//           fontSize:"14px",
//         }}
//       >
//         Unlock more via SMS: • Personalized results • Buy now/wait advice • Deal alerts • Unlimited
//       </Typography>
// }
//        {/* Input and Button Container */}
//     <Box
//       sx={{
//         display: "flex",
//         gap: 1,
//         width: "100%",
//         maxWidth: "400px",
//         alignItems: "stretch",
//       }}
//     >
//       {/* Input Number Box */}
//       {!isSubmittingPhone ?
//       <>
//       <input
//         type="tel"
//         id="userPhoneNumber"
//         placeholder="Enter your phone number"
//         value={userPhoneNumber}
//         onChange={(e) => setUserPhoneNumber(e.target.value)}
//         disabled={isSubmittingPhone}
//         style={{
//           flex: 1,
//           padding: "12px 16px",
//           fontSize: "14px",
//           border: "1px solid rgba(255, 255, 255, 0.3)",
//           borderRadius: "8px",
//           backgroundColor: "white",
//           color: "black",
//           outline: "none",
//           transition: "all 0.3s",
//         }}
//         onFocus={(e) => {
//           e.target.style.backgroundColor = "white";
//           e.target.style.borderColor = "#ff007f";
//         }}
//         onBlur={(e) => {
//           e.target.style.backgroundColor = "white";
//           e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
//         }}
//         onKeyDown={(e) => {
//       if (e.key === "Enter" && !isSubmittingPhone) {
//         handlePhoneSubmit();
//       }
//     }}
//       />

//       {/* Submit Button */}
//       <button
//         style={{
//           padding: "12px 32px",
//           backgroundColor: "#ff007f",
//           color: "white",
//           border: "none",
//           borderRadius: "8px",
//           cursor: "pointer",
//           fontWeight: "bold",
//           fontSize: "14px",
//           transition: "background-color 0.3s, transform 0.2s",
//           whiteSpace: "nowrap",
//         }}
//         onClick={handlePhoneSubmit}
//     disabled={isSubmittingPhone}
//         onMouseEnter={(e) => {
//       if (!isSubmittingPhone) {
//         e.target.style.backgroundColor = "#e6006f";
//         e.target.style.transform = "scale(1.02)";
//       }
//     }}
//     onMouseLeave={(e) => {
//       if (!isSubmittingPhone) {
//         e.target.style.backgroundColor = "#ff007f";
//         e.target.style.transform = "scale(1)";
//       }
//     }}
//     onMouseDown={(e) => !isSubmittingPhone && (e.target.style.transform = "scale(0.98)")}
//     onMouseUp={(e) => !isSubmittingPhone && (e.target.style.transform = "scale(1.02)")}
//   >
//         {isSubmittingPhone ? "Sending..." : "Submit"}
//       </button>
//       </>
//             :
//             <Typography style={{color:"white",textAlign:"center",fontSize:"14px"}}>Check your text messages in 60 seconds to talk to your personal shopper</Typography>

//         }
//     </Box>
//     {!isSubmittingPhone &&
//       <Typography style={{color:"white",fontSize:"12px"}}>Free 7-day trial • Cancel anytime • No spam</Typography>
//     }
//     </Box>
//   </Box>
""
)}
      </Box>
    </>
  );
}